<template>
  <div class="home">
    <HeroSection/>
    <TechMarquee/>
    <BusinessLinesSection/>
    <TechBaseSection/>
    <ScenesSection/>
    <WhySection/>
    <DemoBand/>
    <InsightsSection/>

    <CtaBand
      eyebrow="Let's Talk"
      title="有一个现场想数字化？先聊可行性"
      desc="告诉我们你的地块、产线或业务系统现状，皓辰会在一个工作日内给出初步判断与思路。"
      :bg="img('gen/cta-bg.jpg')"
    />
  </div>
</template>

<script>
import HeroSection from '@/components/home/HeroSection'
import TechMarquee from '@/components/home/TechMarquee'
import BusinessLinesSection from '@/components/home/BusinessLinesSection'
import TechBaseSection from '@/components/home/TechBaseSection'
import ScenesSection from '@/components/home/ScenesSection'
import WhySection from '@/components/home/WhySection'
import InsightsSection from '@/components/home/InsightsSection'
import CtaBand from '@/components/common/CtaBand'
import DemoBand from '@/components/common/DemoBand'
import img from '@/utils/assets'

export default {
  name: 'Home',
  components: {
    HeroSection,
    TechMarquee,
    BusinessLinesSection,
    TechBaseSection,
    ScenesSection,
    WhySection,
    InsightsSection,
    CtaBand,
    DemoBand
  },
  data() {
    return { img }
  }
}
</script>

<style scoped>
.home { position: relative; }
</style>
